module.exports = __webpack_public_path__ + "img/ewm3.23292710.png";